import { defineStore } from 'pinia';
import type { UserInfo } from "@/types/UserModel";
import { UserService } from "@/consumers/UserService";

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as UserInfo | null
  }),

  getters: {
    getUser: (state) => {
      if (state.user === null) {
        const storedUser = localStorage.getItem("userInfo");
        if (storedUser != null) {
          state.user = JSON.parse(storedUser) as UserInfo;
        }
      }
      return state.user;
    }
  },

  actions: {
    setUser(user: UserInfo | null) {
      if (user === null) {
        localStorage.removeItem("userInfo");
      } else {
        localStorage.setItem("userInfo", JSON.stringify(user));
      }
      this.user = user;
    },
    async platformLogin(token: string) {
      const userSvc = new UserService();
      const response = await userSvc.platformLogin(token);

      if (!response.IsSuccess || !response.Value) {
        throw new Error(response.Message ?? "Platform login failed");
      }

      this.setUser(response.Value);
      return response.Value;
    }
  }
}); 
